import { z } from "zod";

import { Enrichments } from "@/enum/enrichments.enum";
import { MetaDataSchema } from "@/schemas/meta-data";

import { ApolloOrgSchema } from "../../Apollo/schema/apolloOrg";
import { ApolloPeopleResponseSchema } from "../../Apollo/schema/get-apollos";

export const LiSnResultSchema = z.object({
	id: z.number(),
	liSnId: z.number(),
	name: z.string().nullable(),
	firstName: z.string().nullable(),
	lastName: z.string().nullable(),
	linkedinUrl: z.string().nullable(),
	companyLocation: z.string().nullable(),
	companyCity: z.string().nullable(),
	companyState: z.string().nullable(),
	companyCountry: z.string().nullable(),
	companyName: z.string().nullable(),
	cleanedCompanyName: z.string().nullable(),
	companyDomain: z.string().nullable(),
	companyLinkedinUrl: z.string().nullable(),
	title: z.string().nullable(),
	headline: z.string().nullable(),
	location: z.string().nullable(),
	city: z.string().nullable(),
	state: z.string().nullable(),
	country: z.string().nullable(),
	status: z.nativeEnum(Enrichments),
	prospect: ApolloPeopleResponseSchema.optional(),
	organization: ApolloOrgSchema.optional(),
});

export const LiSnResultsResponseSchema = z.object({
	data: z.array(LiSnResultSchema),
	meta: MetaDataSchema,
});

export type LiSnResult = z.infer<typeof LiSnResultSchema>;

export type LiSnResultsResponse = z.infer<typeof LiSnResultsResponseSchema>;
